export default {
  init(vue) {
    return {
      getCarrierList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getCarrierList`,
          params: { showAll: true, ...params }
        })
      },
      /**
       * 根据收货地址判断是否需要发送身份证照片
       * receiverProvinceCode ，receiverCityCode，receiverAdd收货人省份编码，地市编码和收货详细地址
       */
      isNotNeedIdImg(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/snyd/card/isNotNeedIdImg`,
          params: params
        })
      },
      /**
       * 获取套餐
       *  @param {carrierId, type} params 
       */
      getProductPackageList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getProductPackageList`,
          params: params
        })
      },
      /**
       * 获取号池
       * @param {carrierId, packageId, areaCode} params 
       */
      getNumberPool(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getNumberPool`,
          params: params
        })
      },
      /**
       * 获取运营商下的套餐(包)列表
       * @param {type, carrierId, packageName} params 
       * @returns 
       */
      getCarrierPackageList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getCarrierPackageList`,
          params: params
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/carrier.service.js